(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Zone = (function(superClass) {
    extend(Zone, superClass);

    function Zone(parent, data) {
      var geom, gj, ref, ref1, ref2, ref3, ref4;
      if (data == null) {
        data = {};
      }
      this.getColor = bind(this.getColor, this);
      Zone.__super__.constructor.call(this);
      this.ignore(['selected', 'acres', 'name', 'rawAcres']);
      this.parent = parent;
      this.name = (ref = data.name) != null ? ref : "Zone";
      this.value = ko.observable((ref1 = data.value) != null ? ref1 : null);
      if ((data.geometry != null) && !(data.geometry instanceof L.FeatureGroup)) {
        geom = new L.FeatureGroup();
        gj = new L.GeoJSON(data.geometry);
        L.GeoUtil.unnestAdd(geom, gj);
      } else {
        geom = (ref2 = data.geometry) != null ? ref2 : new L.FeatureGroup();
      }
      this.geometry = geom;
      this.rawAcres = (ref3 = data.rawAcres) != null ? ref3 : 0;
      this.acres = (ref4 = data.acres) != null ? ref4 : 0.00;
      this.selected = ko.computed((function(_this) {
        return function() {
          var ref5, ref6;
          if (((ref5 = _this.parent) != null ? ref5.selectedFeature : void 0) == null) {
            return false;
          }
          if (((ref6 = _this.geometry._cloneProperties) != null ? ref6.id : void 0) === _this.parent.selectedFeature()) {
            return true;
          }
          return false;
        };
      })(this));
      this.transform((function(_this) {
        return function(v, key) {
          var r, wkt;
          if (key === "geometry") {
            wkt = new Wkt.Wkt();
            r = wkt.fromObject(v).write();
            return r;
          } else {
            return v;
          }
        };
      })(this));
      this.transform((function(_this) {
        return function(v, key) {
          if (key === "value") {
            if (v === true) {
              return "true";
            } else if (v === false) {
              return "false";
            } else if (v == null) {
              return "";
            } else {
              return v;
            }
          } else {
            return v;
          }
        };
      })(this));
    }

    Zone.prototype.getColor = function() {
      var ref, ref1;
      return (ref = this.geometry._cloneProperties) != null ? (ref1 = ref.colorSet) != null ? ref1.fillColor : void 0 : void 0;
    };

    return Zone;

  })(KoModel);

}).call(this);
